import { formatDate } from './format/date';

export interface PasskeyRow {
  id: string;
  nickname: string | null;
  created_at: string;
  last_used_at: string | null;
}

export interface PasskeyManagerLabels {
  title: string;
  description: string;
  empty: string;
  add: string;
  remove: string;
  created: string; // "Added {{date}}"
  lastUsed: string; // "Last used {{date}}"
  neverUsed: string;
}

export interface PasskeyManagerProps {
  passkeys: PasskeyRow[];
  labels: PasskeyManagerLabels;
  onAdd: () => void;
  onRemove: (id: string) => void;
  locale: string;
}

const fill = (template: string, date: string): string => template.replace('{{date}}', date);

// Presentational passkey list. Actions supplied by the consumer; dates go
// through the shared formatter, and the {{date}} interpolation is done
// inline so the component needs no i18n runtime.
export const PasskeyManager = ({ passkeys, labels, onAdd, onRemove, locale }: PasskeyManagerProps) => (
  <div className="passkey-manager">
    <h3 className="title is-6">{labels.title}</h3>
    <p className="mb-3 is-size-7 has-text-grey">{labels.description}</p>

    {passkeys.length === 0 ? (
      <p className="mb-3">{labels.empty}</p>
    ) : (
      <ul className="mb-3">
        {passkeys.map((pk) => (
          <li key={pk.id} className="is-flex is-justify-content-space-between is-align-items-center mb-2">
            <span>
              <strong>{pk.nickname}</strong>
              <br />
              <span className="is-size-7 has-text-grey">
                {fill(labels.created, formatDate(pk.created_at, locale))}
                {' · '}
                {pk.last_used_at ? fill(labels.lastUsed, formatDate(pk.last_used_at, locale)) : labels.neverUsed}
              </span>
            </span>
            <button type="button" className="button is-small is-danger is-light" onClick={() => onRemove(pk.id)}>
              {labels.remove}
            </button>
          </li>
        ))}
      </ul>
    )}

    <button type="button" className="button is-small" onClick={onAdd}>
      {labels.add}
    </button>
  </div>
);
